webpackJsonp([73],{

/***/ 1623:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(823);


/***/ }),

/***/ 823:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(98);

var _datetime2 = _interopRequireDefault(_datetime);

var _ja = __webpack_require__(569);

var _ja2 = _interopRequireDefault(_ja);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('ja', _ja2.default);

/***/ })

},[1623]);


// WEBPACK FOOTER //
// app/datetime.ja-bf478c91914d8bfb0b59.js